module.exports = __webpack_public_path__ + "static/media/014.19ac6aa1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/014.jpg
// module id = 361
// module chunks = 0